import { render, staticRenderFns } from "./PerkPointLabel.vue?vue&type=template&id=1d796bb5&scoped=true"
import script from "./PerkPointLabel.vue?vue&type=script&lang=js"
export * from "./PerkPointLabel.vue?vue&type=script&lang=js"
import style0 from "./PerkPointLabel.vue?vue&type=style&index=0&id=1d796bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d796bb5",
  null
  
)

export default component.exports